import React, { Component } from "react"
import styled from "styled-components"
import {
  ACTIVE_TEXT,
  SECONDARY_TEXT,
  PRIMARY_TEXT,
  TINY_SHADOW
} from "./consts/colors.js"
import TinyButton from "./Button"
import Icon from "./Icons"

const SignUpContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 25px 0px 0px 0px;

  @media (max-width: 480px) {
    padding: 5px 0px;
    font-size: 14px;
  }
`

const TinyInput = styled.input`
  position: relative;
  padding: 20px 10px;
  background-color: white;
  height: 50px;
  width: 420px;
  border-radius: 8px;
  border: none;
  outline: none;
  font-size: 17px;
  font-weight: 700;
  box-shadow: 0px 1px 5px ${TINY_SHADOW};
  color: ${ACTIVE_TEXT};
  letter-spacing: 0.5px;
  ::placeholder {
    color: ${SECONDARY_TEXT};
    font-weight: 400;
  }
  :active,
  :focus {
    box-shadow: 0px 4px 10px ${TINY_SHADOW};
  }
`

const InputSubmit = styled.a`
  position: relative;
  z-index: 3;
  right: 40px;
  padding-top: 8px;
  transition: all 200ms ease;
  &:hover {
    transform: translateX(3px);
  }
`

const TinySignUp = props => (
  <SignUpContainer>
    <TinyInput placeholder="Name Your Store" />
    <InputSubmit href="#">
      <Icon name="forward" />
    </InputSubmit>
  </SignUpContainer>
)
export default TinySignUp



// WEBPACK FOOTER //
// ./src/components/TinySignUp.js